/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash.isempty';
// import { EMAIL_LOGIN_PAGE } from '../../constants/pages';
import { useHistory } from 'react-router';
import Registration, {
  RegistrationLoginLink,
} from '../../components/Registration/Registration';
import SidebarBackgroundImage from '../../assets/images/svg/background-1.svg';
import Logo from '../../components/Logo/Logo';
import themeColors from '../../assets/styles/themeColors';
import { variables } from '../../assets/styles/variables';
import { mediaBelow } from '../../assets/styles/helper';
// import { ReactComponent as ArrowLeft } from '../../assets/images/svg/chevron-left.svg';
import config from '../../config';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import LoaderIcon from '../../components/Loader/LoaderIcon';
import LoaderContainer from '../../components/Loader/LoaderContainer';
import LoaderWrap from '../../components/Loader/LoaderWrap';
import { EMAIL_LOGIN_PAGE } from '../../constants/pages';
import { useBrokerName } from '../../util/hooks/userBrokerName';

const getSidebarBackground = () => {
  const { brokerTheme } = config;

  switch (brokerTheme) {
    case 'HardAssetsAlliance':
      return SidebarBackgroundImage;

    case 'GoldSilver':
      return;
    case 'Contoso':
      return;
    case 'LegacyPM':
      return;

    default:
      return SidebarBackgroundImage;
  }
};

const RegistrationContainer = styled.div`
  flex: 1 1 auto;
`;

const RegistrationBody = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 1fr;
  height: 100%;
  min-height: calc(100vh - 60px);
  margin-bottom: -7rem;
  overflow: auto;
  z-index: 0;

  ${mediaBelow(variables.breakpoints.bpXl)} {
    margin-bottom: -4rem;
  }

  ${mediaBelow(variables.breakpoints.bpLg)} {
    display: flex;
    flex-direction: column;
  }
`;

const RegistrationSidebar = styled.div`
  ${({ isGS }) =>
    isGS
      ? `background: url(${getSidebarBackground()}), ${
          themeColors.colorSidebarBegin
        };`
      : `background-image: url(${getSidebarBackground()});
    `};
  background-size: ${({ isGS }) => (isGS ? 'contain' : 'cover')};
  ${({ isGS }) =>
    isGS && `background-repeat: no-repeat; background-position: right bottom`};
  padding: 1.5rem;

  svg {
    color: ${themeColors.colorHeaderLogoLight};
    height: 1.75rem;
    object-fit: contain;
  }

  ${mediaBelow(variables.breakpoints.bpLg)} {
    ${({ isGS }) =>
      isGS
        ? `background: ${themeColors.colorSidebarBegin};`
        : `background-image: url(${getSidebarBackground()});
      `};
  }
`;

const RegistrationStepWrapper = styled.div`
  padding: 2rem 1.5rem 3rem;
  max-width: 568px;
  width: 100%;
`;

const RegistrationContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RegistrationTitle = styled.h2`
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.6;
  color: ${themeColors.colorTextPrimary};
  margin-top: 0px;
  text-align: left;
`;

const RegistrationSubtitle = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: ${themeColors.colorText};
  font-weight: 600;
  margin-bottom: 28px;
  line-break: loose;
`;

// const RegistrationDescription = styled.p`
//   font-size: 1rem;
//   line-height: 1.6;
//   color: ${themeColors.colorTextPrimary};
//   font-weight: 400;
//   margin-bottom: 28px;
// `;

// const RegistrationBackButton = styled.button`
//   display: flex;
//   align-items: center;
//   color: ${themeColors.colorTextPrimary};
//   text-decoration: none;
//   font-size: 1.1rem;
//   font-weight: 400;
//   background: none;
//   cursor: pointer;
//   outline: none;
//   border: none;
//   width: max-content;
//   margin-bottom: 0.75rem;

//   svg {
//     height: 14px;
//     margin-right: 13px;
//   }
// `;

const RegistrationPage = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  const settings = useSelector(selectSettings);
  const [registrationUrl, setRegistrationUrl] = useState('');
  const history = useHistory();
  const brokerName = useBrokerName();

  useEffect(() => {
    if (!settings || isEmpty(settings)) {
      return;
    }
    const { BrokerCode, IsQuickRegistrationActive } = settings;
    if (BrokerCode && !IsQuickRegistrationActive) {
      const regUrl = settings?.RegistrationUrlV2;
      setRegistrationUrl(regUrl);
    }
  }, [settings]);

  // const goStepBack = () => {
  //   history.push(EMAIL_LOGIN_PAGE);
  // };

  if (registrationUrl && registrationUrl.length > 0) {
    window.location.replace(registrationUrl);
  }

  if (
    !settings ||
    isEmpty(settings) ||
    settings?.BrokerName === undefined ||
    settings?.IsQuickRegistrationActive === undefined
  ) {
    return (
      <LoaderContainer>
        <LoaderWrap data-cy="loading-indicator">
          <LoaderIcon />
        </LoaderWrap>
      </LoaderContainer>
    );
  }

  return (
    <RegistrationContainer>
      <RegistrationBody>
        <RegistrationSidebar isGS={config?.brokerTheme === 'GoldSilver'}>
          <Logo />
        </RegistrationSidebar>
        <RegistrationContent>
          <RegistrationStepWrapper>
            {/* Commenting this out but if user manually enters the quick reg 
            url in browser after hitting login page it takes them back. 
            May be reinstated in future */}
            {/* <RegistrationBackButton onClick={goStepBack}>
              <ArrowLeft />
              {t('common.back')}
            </RegistrationBackButton> */}
            <RegistrationTitle>
              {t('quickRegistration.title')}
            </RegistrationTitle>
            <RegistrationSubtitle>
              {t('quickRegistration.subtitle', {
                brokerName,
              })}

              <RegistrationLoginLink
                onClick={() => {
                  history.push(EMAIL_LOGIN_PAGE);
                }}
              >
                {t('registration.signIn')}
              </RegistrationLoginLink>
            </RegistrationSubtitle>
            <Registration />
          </RegistrationStepWrapper>
        </RegistrationContent>
      </RegistrationBody>
    </RegistrationContainer>
  );
};

RegistrationPage.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
  }),
};
export default RegistrationPage;
